"use client";

import Link from "next/link";

import { NAV_RAIL_WIDTH } from "@/components/nav/nav-styles";
import WorkspaceSwitcher, {
  WorkspaceLogo,
} from "@/components/nav/WorkspaceSwitcher";
import { cn } from "@/lib/utils";

/**
 * The band across the top of the rail and the panel, holding the studio's
 * mark. With the panel open it has the whole nav's width and shows the logo
 * at 40px tall and as wide as it is; with the panel hidden it narrows to the
 * rail and shows nothing, keeping its height so the search row and the rail
 * stay put when the panel toggles. For someone who can switch studios the
 * logo is the switcher's trigger (`WorkspaceSwitcher`), otherwise a link
 * home; either way it is its own name.
 */
export default function StudioBand({
  displayName,
  displayLogo,
  switcher,
  wide,
}) {
  return (
    <div
      className={cn(
        "flex h-16 shrink-0 items-center overflow-hidden",
        wide ? "px-4" : NAV_RAIL_WIDTH,
      )}
    >
      {wide &&
        (switcher ? (
          <WorkspaceSwitcher {...switcher} />
        ) : (
          <Link
            href="/"
            className="flex items-center rounded-lg px-2 py-1 transition-colors hover:bg-stone-200/50"
          >
            <WorkspaceLogo
              workspace={{ name: displayName, image: displayLogo }}
            />
          </Link>
        ))}
    </div>
  );
}
